import React from "react";
import { styled } from "@styles";
import { h5, body1 } from '@typo/typo.module.css';
import { textPrimary } from '@typo/color.module.css';
import { Button } from "@atoms";

const Wrapper = styled.div`
  text-align: center;
`;

const ErrorCode = styled.p`
  padding: 1rem;
`;

export const P = styled.p`
  color: #fd346a;
`;

export interface IProps {
  handleTryAgain: any,
  handleCancelOrder: any
}
const OrderDetailFailed: React.FC<IProps> = ({
   handleTryAgain,
   handleCancelOrder
}: IProps) => {
  const searchParams = new URLSearchParams(document.location.search);
  const simplErrorCode = searchParams.get('error_code');

  return (
    <Wrapper>
      <p className={[h5, textPrimary].join(" ")}>
        Oh no, your payment failed
      </p>
      <ErrorCode className={[body1].join(" ")}>
        {simplErrorCode}
      </ErrorCode>
      <p className={[body1].join(" ")}>
        Please try again
      </p>
      <P onClick={handleCancelOrder}>
        Do you want to cancel the order?
      </P>
      <Button onClick={handleTryAgain}>
        Try again &gt;
      </Button>
    </Wrapper>
  );
}

export { OrderDetailFailed }